import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["orderMode", "linkField", "pdfField", "otherField"]

  declare readonly orderModeTargets: HTMLInputElement[]
  declare readonly linkFieldTarget: HTMLElement
  declare readonly hasLinkFieldTarget: boolean
  declare readonly pdfFieldTarget: HTMLElement
  declare readonly hasPdfFieldTarget: boolean
  declare readonly otherFieldTarget: HTMLElement
  declare readonly hasOtherFieldTarget: boolean

  connect() {
    this.toggleOrderMode()
  }

  toggleOrderMode() {
    const selected = this.orderModeTargets.find(r => r.checked)
    const mode = selected?.value || "link"
    if (this.hasLinkFieldTarget) {
      this.linkFieldTarget.hidden = mode !== "link"
    }
    if (this.hasPdfFieldTarget) {
      this.pdfFieldTarget.hidden = mode !== "pdf"
    }
    if (this.hasOtherFieldTarget) {
      this.otherFieldTarget.hidden = mode !== "other"
    }
  }
}
